import Vue from 'vue'
import Component from 'vue-class-component'
import ShareButton from "@/components/buttons/ShareButton.vue";
import statementStore from '@/store/statement/statement-store'
import convoStore from '@/store/convo/convo-store';
import { IConvo } from '@/model/convo';
import authStore from '@/store/auth/auth-store';
import { IStatement } from '@/model/statement';
import LoginButton from '@/components/buttons/LoginButton';
import JybeButtonNonauth from '@/components/buttons/JybeButtonNonauth';

@Component({
  name: 'statementReact',
  props: ['statement', 'convo'],
  components: {
    'jybe-nonauth-button': JybeButtonNonauth,
    'login-button': LoginButton,
    'share-button': ShareButton
  }
})
export default class StatementNonauth extends Vue {

  get canAddToConvo(): boolean {
    return this.isConvoCreator() && !this.convoHasStatement()
  }

  isConvoCreator(): boolean {
    const convo = this.getConvo();
    if(authStore.user && convo && convo.meta && convo.meta.creator.id === authStore.user.id) return true
    else return false 
  }

  convoHasStatement(): boolean|null {
    const convo = this.getConvo();
    return convo.meta && convo.meta.statements.indexOf(this.getStatement()) >= 0;
  }

  getStatement (): IStatement {
    return this.$props['statement'] as IStatement
  }

  getConvo (): IConvo {
    return this.$props['convo'] as IConvo
  }

  protected addConvoCommentStatement(): void {
    convoStore.dispatchAddConvoCommentStatement({convo: this.getConvo(), statement: this.$props['statement']})
  }

  protected copyStatement (): void {
    statementStore.dispatchCopyStatement(this.$props['statement'])
  }
}
